import Button from "react-bootstrap/Button";
import React from "react";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import { removeShopifyCartItemBulk } from "../../actionCreators/cart";
import RewardsPlusMembershipStatusBanner from "../rewards-plus/RewardsPlusMembershipStatusBanner";

const CartHeader = ({dismissCart}) => {
    const dispatch = useDispatch();
    const { cartCount, cart, is_cart_busy, user_profile } = useSelector(state => ({
        cartCount: state.shopifyReducer.cartCount,
        cart: state.shopifyReducer.checkout,
        is_cart_busy: state.shopifyReducer.is_cart_busy,
        user_profile: state.myAccountReducer.user_profile,
    }));
    const trade_in_bags = sessionStorage.getItem("trade_in_bags") ? JSON.parse(sessionStorage.getItem("trade_in_bags")) : [];
    const trade_in_bags_count = trade_in_bags.length;

    return (
        <Modal.Header className="cart-popup__header">
            <Modal.Title
                as={"div"}
                className="cart-popup__title"
            >
                {(cartCount > 0 || trade_in_bags_count > 0) ? "Your Cart" : ""}
                <RewardsPlusMembershipStatusBanner/>
            </Modal.Title>
            {user_profile && user_profile.is_b2b && cart && cartCount > 0 &&
            <Button
                onClick={() => dispatch(removeShopifyCartItemBulk(cart.lines))}
                className="cart-row__clyde-remove-btn"
                variant="clean"
            >
                Clear Entire Cart
            </Button>
            }
            <Button
                className="cart-popup__close-icon"
                onClick={() => dismissCart(is_cart_busy)}
                variant="clean"
                aria-label="Close"
            >
                <span className="icon-close"/>
            </Button>
        </Modal.Header>
    );
}

export default CartHeader;